module.exports = __webpack_public_path__ + "static/media/Janelle Grass_2.57a29bfd.jpg";